import { render } from "./FormBox.vue?vue&type=template&id=df0206e2"
import script from "./FormBox.vue?vue&type=script&lang=js"
export * from "./FormBox.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./FormBox.vue?vue&type=style&index=0&id=df0206e2&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script